// import { DISTORTION_SETTINGS } from '../_app/cuchillo/3D/materials/DistortedPixelMaterial';
import { Basics, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Movable {
  static _items = [];
  static _zIndex = 100;

  static set zIndex(n) { this._zIndex = n };
  static get zIndex() {
    this._zIndex++;
    return this._zIndex;
  }

  static _callUp = () => { Movable.up(); }

  container;
  target;
  // _wrapper;
  _offset = { x: 0, y: 0, z: 1 };
  _position = { x: 0, y: 0, z: 0 };
  _targetPosition = { x: 0, y: 0, z: 0 };
  _velocity = { x: 0, y: 0 };
  _isDown = false;
  _lastTime = 0;
  _calls = {
    down: (e) => { this.down(e) },
    up: (e) => { this.up(e) },
    move: (e) => { this.move(e) },
  }

  static init() {
    if (isTouch) return;

    [...GetBy.selector('[data-movable]')].map(dom => {
      this._items.push(new Movable(dom));
    });

    document.addEventListener(Basics.upEvent, Movable._callUp, true);
  }

  static up() {
    this._items.map(item => {
      if (item) item.up();
    });
  }

  static dispose() {
    this._items.map(item => {
      if (item) item.dispose();
    });

    this._items = [];

    document.removeEventListener(Basics.upEvent, Movable.up);
  }

  constructor(__item) {
    this.container = __item;
    this.target = GetBy.class('target', __item)[0];

    this.target.addEventListener(Basics.downEvent, this._calls.down, true);
    document.addEventListener(Basics.moveEvent, this._calls.move); // Escuchar el movimiento globalmente
  }

  down(e) {
    this._isDown = true;
    this._lastTime = Date.now();

    this._offset = {
      x: isTouch ? e.touches[0].screenX : e.clientX,
      y: isTouch ? e.touches[0].screenY : e.clientY,
      z: Movable.zIndex
    };

    this._velocity = { x: 0, y: 0 };

    this.container.classList.add('moving');
    document.body.classList.add('--dragging');
  }

  move(e) {
    if (!this._isDown) return;

    const currentTime = Date.now();
    const timeDiff = currentTime - this._lastTime;

    const pos = {
      x: isTouch ? e.touches[0].screenX : e.clientX,
      y: isTouch ? e.touches[0].screenY : e.clientY,
      z: this._offset.z
    };

    const dx = pos.x - this._offset.x;
    const dy = pos.y - this._offset.y;

    this._velocity = {
      x: dx / timeDiff * 16,
      y: dy / timeDiff * 16
    };

    this._position.x += dx;
    this._position.y += dy;
    this._position.z = pos.z;

    this._offset = {
      x: pos.x,
      y: pos.y,
      z: pos.z,
    };

    this._lastTime = currentTime;

    this.updatePosition();
  }

  up() {
    this._isDown = false;
    // this.applyInertia();
    this.container.classList.remove('moving');
    document.body.classList.remove('--dragging');
  }

  // applyInertia() {
  //   if (Math.abs(this._velocity.x) > 0.1 || Math.abs(this._velocity.y) > 0.1) {
  //     this._position.x += this._velocity.x;
  //     this._position.y += this._velocity.y;

  //     this.container.style.transform = `translate3d(${this._position.x}px, ${this._position.y}px, ${this._position.z}px)`;

  //     this._velocity.x *= 0.95;
  //     this._velocity.y *= 0.95;

  //     requestAnimationFrame(() => this.applyInertia());
  //   }
  // }

  updatePosition() {
    const rect = this.container.getBoundingClientRect();

    if (rect.left < 0) this._position.x += -rect.left;
    if (rect.top < 0) this._position.y += -rect.top;
    if (rect.right > window.innerWidth) this._position.x -= rect.right - window.innerWidth;
    if (rect.bottom > window.innerHeight) this._position.y -= rect.bottom - window.innerHeight;

    this.container.style.transform = `translate3d(${this._position.x}px, ${this._position.y}px, ${this._position.z}px)`;
    this.container.style.zIndex = this._position.z;
  }

  dispose() {
    this.target.removeEventListener(Basics.downEvent, this._calls.down);
    // if (this._wrapper) this._wrapper.removeEventListener(Basics.moveEvent, this._calls.move);

    this.container = null;
    // this._wrapper = null;
    this._offset = null;
    this._position = null;
    this._velocity = null;
    this._isDown = null;
    this._lastTime = null;
  }
}
